import PropTypes from 'prop-types';

export const impedanceModelingPropType = PropTypes.shape({
  copperKey: PropTypes.string,
  name: PropTypes.string,
  signal: PropTypes.bool,
  simulationModel: PropTypes.string,
  thickness: PropTypes.number,
  transmissionWidth: PropTypes.number,
  transmissionSpacing: PropTypes.number,
  selectedImpedance: PropTypes.shape({
    frequency: PropTypes.string,
    mhz: PropTypes.number,
    params: PropTypes.objectOf(PropTypes.number)
  })
});

export default {
  impedanceModelingPropType
}



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ResultViewer/propTypes.js